"use strict";module.exports=URIError;